import '@plugins/inlineManual/style.css';

export const INLINE_MANUAL_STYLE_ID = 'inline-manual-runtime-style';

const INLINE_MANUAL_RULE_SIGNATURES = [
    '.inmplayer-popover-progress-bar',
    '.im-builder-content-component',
    '.inmplayer-popover',
    '.inmplayer-button'
];

const getStyleElement = root => {
    if (root && typeof root.getElementById === 'function') {
        return root.getElementById(INLINE_MANUAL_STYLE_ID);
    }

    if (root && typeof root.querySelector === 'function') {
        return root.querySelector(`#${INLINE_MANUAL_STYLE_ID}`);
    }

    return null;
};

const getInlineManualCssText = () => {
    if (typeof document === 'undefined') {
        return '';
    }

    const chunks = [];
    const styleSheets = Array.from(document.styleSheets || []);

    styleSheets.forEach(sheet => {
        let rules = null;
        try {
            rules = sheet.cssRules;
        } catch (error) {
            // Ignore inaccessible stylesheets (e.g. external cross-origin styles).
            return;
        }

        if (!rules) {
            return;
        }

        Array.from(rules).forEach(rule => {
            const cssText = rule.cssText || '';
            if (INLINE_MANUAL_RULE_SIGNATURES.some(signature => cssText.includes(signature))) {
                chunks.push(cssText);
            }
        });
    });

    return chunks.join('\n');
};

export const ensureInlineManualStyles = root => {
    if (!root || typeof document === 'undefined') {
        return;
    }

    // The regular document already gets style.css from the import above.
    if (root === document) {
        return;
    }

    if (getStyleElement(root)) {
        return;
    }

    const cssText = getInlineManualCssText();
    if (!cssText) {
        return;
    }

    const style = document.createElement('style');
    style.id = INLINE_MANUAL_STYLE_ID;
    style.textContent = cssText;

    if (root.head && typeof root.head.appendChild === 'function') {
        root.head.appendChild(style);
        return;
    }

    if (typeof root.appendChild === 'function') {
        root.appendChild(style);
    }
};
